import type { ConfidenceFactor } from '@dill/dill-shared';

/**
 * The derivation behind a confidence score, as a list.
 *
 * Rendered identically wherever the score is shown — the badge tooltip in the queues, the
 * allocation modal, and Post History — because an explanation that is worded three ways is three
 * explanations, and the operator has no way to tell which one the number came from.
 *
 * Each factor carries the running score *after* it applied, so the last row is always the badge.
 */
export const ConfidenceFactorList = ({ factors }: { factors: ConfidenceFactor[] }) => {
  if (factors.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2.5">
      {factors.map((factor) => (
        <div key={factor.key}>
          <div className="flex items-baseline justify-between gap-2">
            <p className="text-xs font-semibold text-gray-900">{factor.label}</p>
            <p className="text-xs font-semibold text-gray-500 tabular-nums">
              {Math.round(factor.score * 100)}%
            </p>
          </div>
          <p className="text-[11px] leading-snug text-gray-500">{factor.detail}</p>
        </div>
      ))}
    </div>
  );
};
